import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface NDConnectReadyProps {
  handleClose: () => void;
  readyUrl: string;
  showReadyDialog: boolean;
}

export const NDConnectReady = ({ handleClose, readyUrl, showReadyDialog }: NDConnectReadyProps) => {
  return (
    <>
      <Dialog
        open={showReadyDialog}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontSize: '18px' }}>Console Access Ready</DialogTitle>
        <DialogContent>
          {readyUrl ? (
            <>
              <Typography sx={{ mb: 2 }}>
                Click Open Console to open the console in a new tab:
              </Typography>
              <Typography sx={{ wordBreak: 'break-all', color: 'primary.main' }}>
                {readyUrl}
              </Typography>
            </>
          ) : (
            <Typography>No URL returned from server.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          {readyUrl && (
            <Button
              variant="outlined"
              onClick={() => window.open(readyUrl, '_blank', 'noopener')}
            >
              Open Console
            </Button>
          )}
          <Button variant="outlined" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
